"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

/**
 * A custom hook that executes a callback function when a click event outside of
 * a given element occurs. The element is determined by a ref object or a regular
 * element. The click event can be triggered by a list of custom events.
 *
 * @param {object} options - An object that contains:
 *   - {React.RefObject} ref: A React ref object that points to the element
 *     that we want to track clicks outside of.
 *   - {function} callback: A function that gets executed when a click event outside
 *     of the tracked element occurs.
 *   - {string[]} triggers: An array of strings that define the custom events that
 *     trigger the outside click tracking.
 * @return {void}
 */
const useOutside = ({
  ref,
  callback,
  triggers,
  listeningElement = document
}) => {
  (0, _react.useEffect)(() => {
    const handleOutside = event => {
      if ((ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    triggers.forEach(trigger => listeningElement.addEventListener(trigger, handleOutside, true));
    return () => {
      triggers.forEach(trigger => listeningElement.removeEventListener(trigger, handleOutside, true));
    };
  }, [ref]);
};

var _default = useOutside;
exports.default = _default;